export function useAdnuntius() {
  function adnuntiusFetch(banners, options) {
    if (process.env.VUE_APP_BANNERS_USE_ADNUNTIUS != "true") return;
    const adUnits = banners.reduce((arr, b) => {
      if (b.contentType == "EXTERNAL_ADNUNTIUS") {
        const [, auId] = b.contentText.split("_");
        arr.push({
          auId,
          auW: options.maxWidth,
          auH: options.maxHeight,
          targetClass: `adn-${auId}`,
          clearTarget: true,
          requestTiming: "immediate",
          requestParams: { proximity: 20, load: "lazy" }
        });
      }
      return arr;
    }, []);

    if (adUnits.length == 0) return;

    const [network] = banners
      .find(b => b.contentType == "EXTERNAL_ADNUNTIUS")
      .contentType.split("_");

    window.adn.calls.push(function () {
      window.adn.request({
        network,
        adUnits
      });
    });
  }

  return {
    adnuntiusFetch
  };
}
